import * as Yup from 'yup';

import { ValidationErrorMessages } from '@constants/forms';

export const validationSchema = Yup.object({
  declarations: Yup.object({
    age: Yup.boolean(),
    existingCondition: Yup.boolean(),
    working: Yup.boolean(),
    myself: Yup.boolean(),
  }).test(
    'all-declarations-checked',
    ValidationErrorMessages.CONFIRM_POLICY_DOCUMENTS,
    (value) => {
      if (!value) return false;
      return (
        value.age && value.existingCondition && value.working && value.myself
      );
    }
  ),
});
export type IPLegalSectionValues = Yup.InferType<typeof validationSchema>;
